import { Link } from "wouter";
import { blogPosts } from "@/lib/blogData";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Calendar, Clock, ArrowRight } from "lucide-react";

export default function BlogPage() {
  return (
    <div className="min-h-screen bg-[#F8F9FC]">
      <Header />
      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-4">
          {/* Page header */}
          <div className="mb-12 text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-[#1A3C6E]/10 text-[#1A3C6E] text-xs font-semibold uppercase tracking-wider mb-3">
              Блог
            </span>
            <h1
              className="text-3xl sm:text-4xl font-black text-[#0A1628] mb-3"
              style={{ fontFamily: "var(--font-display)" }}
            >
              Визний мэдлэг & Зөвлөмж
            </h1>
            <p className="text-gray-500 text-sm max-w-xl mx-auto" style={{ fontFamily: "var(--font-body)" }}>
              Мэргэжлийн зөвлөмж, амжилтын түүхүүд болон визийн мэдээллийг эндээс уншина уу.
            </p>
          </div>

          {/* Blog post list */}
          <div className="space-y-6">
            {blogPosts.map((post) => (
              <Link key={post.slug} href={`/blog/${post.slug}`}>
                <article className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 hover:shadow-md transition-shadow cursor-pointer group">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-[#1A3C6E]/10 text-[#1A3C6E] text-xs font-semibold">
                      {post.category}
                    </span>
                    <span className="flex items-center gap-1 text-gray-400 text-xs">
                      <Calendar size={12} />
                      {new Date(post.date).toLocaleDateString("mn-MN", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                    <span className="flex items-center gap-1 text-gray-400 text-xs">
                      <Clock size={12} />
                      {post.readTime}
                    </span>
                  </div>
                  <h2
                    className="text-xl sm:text-2xl font-black text-[#0A1628] mb-2 group-hover:text-[#1A3C6E] transition-colors"
                    style={{ fontFamily: "var(--font-display)" }}
                  >
                    {post.title}
                  </h2>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4" style={{ fontFamily: "var(--font-body)" }}>
                    {post.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-[#1A3C6E] text-sm font-semibold group-hover:gap-2.5 transition-all">
                    Дэлгэрэнгүй унших <ArrowRight size={14} />
                  </span>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
